<script>
export default {
  name: 'DraggableList',
  props: {
    itemsRaw: Array,
    canReceive: Boolean,
    type: String,
  },
  data() {
    return {
      prevHoveredItem: null,
      draggableIndex: null,
    };
  },
  computed: {
    draggableType() { return this.$store.state.draggable.type; },
    draggableItem() {
      const { item } = this.$store.state.draggable;

      return this.canReceive
        ? item
        : this.itemsRaw.find(i => i === item);
    },
    itemsComputed() {
      if (!this.draggableItem) return this.itemsRaw;

      const items = this.itemsRaw.filter(i => i !== this.draggableItem);

      if (this.draggableIndex !== null) {
        items.splice(this.draggableIndex, 0, this.draggableItem);
      }

      return items;
    },
  },
  methods: {
    onDragStart(e, item) {
      e.dataTransfer.effectAllowed = 'move';
      const { type } = this;
      this.$store.commit('draggable/set', { item, type });
      this.draggableIndex = this.itemsRaw.indexOf(item);
    },
    onDragEnter(e, hoverItem) {
      if (this.type !== this.draggableType) return;
      e.preventDefault();

      // fix for EmptyList
      if (!hoverItem) {
        this.draggableIndex = 0;
      }

      if (!e.target.draggable) return;
      if (e.target !== e.currentTarget) return;
      if ([this.draggableItem, this.prevHoveredItem].includes(hoverItem)) {
        return;
      }

      this.prevHoveredItem = hoverItem;
      setTimeout(() => { this.prevHoveredItem = null; }, 100);

      this.draggableIndex = this.itemsComputed.findIndex((item) => item === hoverItem);
    },
    onDrop() {
      if (this.type !== this.draggableType) return;
      this.$emit('change', this.itemsComputed);
      this.onDragEnd();
    },
    onDragEnd() {
      this.$store.commit('draggable/set', null);
      this.prevHoveredItem = null;
      this.draggableIndex = null;
    },
  },
};
</script>

<template lang="pug">
.draggable-list(:class="{ grabbed: !!draggableItem }")
  slot(
    :items="itemsComputed"
    :onDragStart="onDragStart"
    :onDragEnter="onDragEnter"
    :onDrop="onDrop"
    :onDragEnd="onDragEnd"
    :draggableItem="draggableItem"
  )
</template>

<style scoped lang="scss">
.draggable-list > * {
  cursor: grab;
}

.drag {
  opacity: .5;
  cursor: grabbing !important; // not working
}
</style>
